<ul class="chatList">
  {{#each chats}}
  <li class="chatList__item">
    <a class="chatList__avatar" href="#"></a>
    <div class="chatList__description">
      <a class="chatList__title" href="#">{{this.title}}</a>
      <p class="chatList__lastMessage">{{this.lastMessage}}</p>
    </div>
    <div class="chatList__common">
      <span class="chatList__date">{{this.date}}</span>
      {{#if this.badge}}
      <span class="chatList__badge">{{this.badge}}</span>
      {{/if}}
    </div>
  </li>
  {{/each}}
</ul>
